import { useMemo } from 'react'
import styled from 'styled-components'

import { StringUtil } from '../../core'

type TruncateProps = {
  children: string
  start: number
  end: number
  ellipsisText?: string
}

export const Truncate: React.FC<TruncateProps> = ({
  children,
  end,
  start,
  ellipsisText = '…',
}) => {
  const truncated = useMemo(
    () => StringUtil.truncateMiddle(children, start, end, ellipsisText),
    [children, ellipsisText, end, start],
  )

  return <Root>{truncated}</Root>
}

const Root = styled.span`
  white-space: nowrap;
`
